var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0625 15.9827V29.6389C33.0625 30.8338 32.1011 31.7952 30.9062 31.7952C29.7113 31.7952 28.75 30.8338 28.75 29.6389V21.1846L16.621 33.3225C15.7765 34.167 14.4109 34.167 13.5753 33.3225C12.7398 32.478 12.7308 31.1124 13.5753 30.2768L25.7043 18.1479L16.5312 18.1389C15.3363 18.1389 14.375 17.1776 14.375 15.9827C14.375 14.7877 15.3363 13.8264 16.5312 13.8264H30.9062C32.1011 13.8264 33.0625 14.7877 33.0625 15.9827Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M0 23.8889C0 29.9889 2.42321 35.839 6.73654 40.1524C11.0499 44.4657 16.9 46.8889 23 46.8889C29.1 46.8889 34.9501 44.4657 39.2635 40.1524C43.5768 35.839 46 29.9889 46 23.8889C46 17.7889 43.5768 11.9388 39.2635 7.62546C34.9501 3.31212 29.1 0.888916 23 0.888916C16.9 0.888916 11.0499 3.31212 6.73654 7.62546C2.42321 11.9388 0 17.7889 0 23.8889ZM33.0625 29.6389C33.0625 30.8338 32.1012 31.7952 30.9062 31.7952C29.7113 31.7952 28.75 30.8338 28.75 29.6389V21.1846L16.6211 33.3225C15.7766 34.167 14.4109 34.167 13.5754 33.3225C12.7398 32.478 12.7309 31.1124 13.5754 30.2768L25.7043 18.1479L16.5312 18.1389C15.3363 18.1389 14.375 17.1776 14.375 15.9827C14.375 14.7877 15.3363 13.8264 16.5312 13.8264H30.9062C32.1012 13.8264 33.0625 14.7877 33.0625 15.9827V29.6389Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendUp);
export default __webpack_public_path__ + "static/media/TrendUp.bb19898e10f9fc622a09a4e8a6c769a4.svg";
export { ForwardRef as ReactComponent };